import { QUERY_GET_FACTORY_CHANNELS } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryChannels = baseThunk(`factoryChannels/getChannels`, QUERY_GET_FACTORY_CHANNELS, "GET")
